export default __webpack_public_path__ + "static/blob1-b3017f06dce546830cd10cd12e8d05b2.svg";